<template>
  <footer class="py-4 footer mt-auto">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="col-lg-6 mb-lg-0 mb-4">
          <div class="copyright text-center text-sm text-muted text-lg-start">
            © {{ new Date().getFullYear() }}, feito com
            <i class="fa fa-heart heartbeat"></i> pela
            <a class="font-weight-bold transition-link">Rifa365</a>.
            <span class="version-badge">v{{ appVersion }}</span>
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="nav-item">
              <a
                href="#"
                class="nav-link text-muted transition-link"
                @click.prevent="termsDialog = true"
                >Termos de Uso</a
              >
            </li>
            <li class="nav-item">
              <a
                href="#"
                class="nav-link text-muted transition-link pe-0"
                @click.prevent="policyDialog = true"
                >Política de Privacidade</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <Terms :isOpen="termsDialog" @close="termsDialog = false" />
    <Policy :isOpen="policyDialog" @close="policyDialog = false" />
  </footer>
</template>

<script>
import Terms from "@/views/Raffles/RafflesCreation/components/Terms.vue";
import Policy from "@/views/Raffles/RafflesCreation/components/Policy.vue";

export default {
  name: "app-footer",
  components: { Terms, Policy },
  data() {
    return {
      appVersion: "",
      termsDialog: false,
      policyDialog: false,
    };
  },
  mounted() {
    this.appVersion = require("../../package.json").version;
  },
};
</script>

<style scoped lang="scss">
.footer {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.version-badge {
  display: inline-block;
  margin-left: 8px;
  background: linear-gradient(135deg, #5900b2, #fb1789);
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
  letter-spacing: 0.5px;
  vertical-align: middle;
}


.heartbeat {
  color: #e41b80;
  animation: heartbeat 1.5s ease-in-out infinite;
  display: inline-block;
}

@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  14% {
    transform: scale(1.3);
  }
  28% {
    transform: scale(1);
  }
  42% {
    transform: scale(1.3);
  }
  70% {
    transform: scale(1);
  }
}

.nav-link {
  font-size: 0.8125rem;
  transition: all 0.2s ease;

  &:hover {
    color: #cb0c9f !important;
    transform: translateY(-1px);
  }
}

.transition-link {
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    color: #cb0c9f !important;
  }
}
</style>
